module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setup-widget text-dark",
    class: [{
      setupWidgetOpen: _vm.showModal
    }, {
      animateSlide: _vm.animateSlide
    }]
  }, [_c('div', {
    staticClass: "setup-widget__button",
    on: {
      "click": _vm.setShowModal
    }
  }, [_c('div', {
    staticClass: "setup-widget__button__text"
  }, [_vm._v(_vm._s(_vm.$t('vue2.setupWidget.get_going_easy')))]), _vm._v(" "), _c('div', {
    staticClass: "pointer setup-widget__button__close"
  }, [(_vm.showModal) ? _c('span', {
    staticClass: "icon-cross2"
  }) : _c('span', {
    staticClass: "icon-arrow-up4"
  })])]), _vm._v(" "), (_vm.showModal && _vm.activeOnboardingStep === 0 && _vm.showLocalOnboardingArrow) ? _c('arrow', {
    style: ({
      'top': _vm.onboardArrowTopPx + 'px'
    }),
    attrs: {
      "setupWidget": true
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "setup-widget__header"
  }, [_c('div', {
    staticClass: "onboarding_section"
  }, [_c('div', {
    staticClass: "setup-widget__header pad-20 pad-0-top"
  }, [_c('h1', {
    staticClass: "center text-white"
  }, [_vm._v(_vm._s(_vm.$t('vue2.setupWidget.get_going_easy')))]), _vm._v(" "), _c('doughnut', {
    attrs: {
      "animate": true,
      "steps": _vm.stepsLength,
      "stepNum": _vm.howManyDone
    }
  })], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "setup-widget__steps"
  }, _vm._l((_vm.stepNumbers), function(step, index) {
    return _c('li', {
      staticClass: "setup-widget__steps__step js-onboard-item-click js-setupWidgetEvent",
      class: {
        'isDone': step.done
      },
      on: {
        "click": function($event) {
          return _vm.stepFnc(step.stepNum, step.title)
        }
      }
    }, [(step.guide.length > 1) ? [_c('div', {
      staticClass: "youtube-popup js-setupWidgetEvent step__button__video-guide",
      on: {
        "click": function($event) {
          return _vm.openYouTube(step.videoid)
        }
      }
    }, [_c('span', {
      staticClass: "step__number js-setupWidgetEvent",
      class: {
        stepNumberDone: step.done
      }
    }, [(step.done) ? _c('span', {
      staticClass: "icon-checkmark4 js-setupWidgetEvent"
    }) : _c('span', {
      staticClass: "step__number__play icon-play4 js-setupWidgetEvent"
    })]), _vm._v(" "), _c('span', {
      staticClass: "step-text js-setupWidgetEvent"
    }, [_vm._v(" " + _vm._s(step.title))])])] : [_c('div', {
      staticClass: "js-setupWidgetEvent step__button__video-guide"
    }, [_c('span', {
      staticClass: "step__number js-setupWidgetEvent",
      class: {
        stepNumberDone: step.done
      }
    }, [(step.done) ? _c('span', {
      staticClass: "icon-checkmark4 js-setupWidgetEvent"
    }) : _c('span', {
      staticClass: "js-setupWidgetEvent"
    }, [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('span', {
      staticClass: "step-text js-setupWidgetEvent"
    }, [_vm._v(" " + _vm._s(step.title))])])]], 2)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "support-section"
  }, [_c('div', {
    staticClass: "support-section__list"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showIntercom.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "icon-bubbles4"
  }), _vm._v("\n        " + _vm._s(_vm.$t('vue2.setupWidget.write_us')))]), _vm._v(" "), (_vm.country === 'dk') ? [_c('a', {
    attrs: {
      "href": "http://support.docendo.dk/"
    }
  }, [_c('span', {
    staticClass: "icon-question3"
  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.setupWidget.support_forum')) + "\n        ")])] : _vm._e()], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-354eb704!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/onboarding/SetupWidget.vue
// module id = 1851
// module chunks = 1